import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { questions, options } from '../data/questions';
interface QuizSectionProps {
  onComplete: (score: number) => void;
}
export const QuizSection: React.FC<QuizSectionProps> = ({
  onComplete
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [score, setScore] = useState(0);
  const handleOptionSelect = (points: number) => {
    const newScore = score + points;
    setTimeout(() => {
      if (currentIndex < questions.length - 1) {
        setCurrentIndex(prev => prev + 1);
        setScore(newScore);
      } else {
        onComplete(newScore);
      }
    }, 250);
  };
  const progress = currentIndex / questions.length * 100;
  return <div className="min-h-screen bg-white px-6 py-12 md:py-24 flex flex-col items-center" data-id="element-112">
      <div className="max-w-xl w-full mx-auto" data-id="element-113">
        {/* Progress Bar */}
        <div className="mb-12" data-id="element-114">
          <div className="flex justify-between text-sm font-semibold text-gray-500 mb-3" data-id="element-115">
            <span data-id="element-116">
              Pregunta {currentIndex + 1} de {questions.length}
            </span>
          </div>
          <div className="w-full h-3 bg-lavender rounded-full overflow-hidden" data-id="element-117">
            <motion.div className="h-full bg-brand-red rounded-full" initial={{
            width: 0
          }} animate={{
            width: `${progress}%`
          }} transition={{
            duration: 0.5,
            ease: 'easeInOut'
          }} data-id="element-118" />
          </div>
        </div>

        {/* Question Card */}
        <div className="relative min-h-[400px]" data-id="element-119">
          <AnimatePresence mode="wait" data-id="element-120">
            <motion.div key={currentIndex} initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.3
          }} className="absolute w-full bg-white rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.08)] p-8 md:p-10 border border-gray-50" data-id="element-121">
              <h2 className="text-2xl md:text-3xl font-bold text-dark-blue mb-8 leading-snug" data-id="element-122">
                {questions[currentIndex]}
              </h2>

              <div className="space-y-3" data-id="element-123">
                {options.map((option, idx) => <button key={idx} onClick={() => handleOptionSelect(option.points)} className="w-full text-left p-5 rounded-2xl border-2 border-lavender hover:border-brand-red hover:bg-red-50 transition-colors font-medium text-gray-700 text-lg" data-id="element-124">
                    {option.label}
                  </button>)}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>;
};